export const CAROUSEL_DISHES =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_288,h_360/";

export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const TOP_PICKS =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_292,h_300/";

export const SUGGESTION_IMG =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_112,h_112,c_fill/";

export const SEARCH_RESULTS_IMG =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";

export const LOGO_URL = "https://cdn.worldvectorlogo.com/logos/swiggy-1.svg";

export const MENU_API =
  "https://swiggy-backend-9o8y.onrender.com/api/menu?resId=";
// "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=22.7195687&lng=75.8577258&restaurantId=";

export const CUISINES = "https://swiggy-backend-9o8y.onrender.com/api/cuisines";
// "https://www.swiggy.com/dapi/landing/PRE_SEARCH?lat=22.7195687&lng=75.8577258";

export const CUISINE_IMG =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/";
